import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import ModuleViewer from "./pages/ModuleViewer";
import ExamIntro from "./pages/ExamIntro";
import ExamAttempt from "./pages/ExamAttempt";
import Verify from "./pages/Verify";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import AuthCallback from "./components/AuthCallback";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RoleGuard } from "./components/RoleGuard";
import { AdminShell } from "./components/AdminShell";
import { SuperAdminShell } from "./components/SuperAdminShell";
import AdminCourses from "./pages/admin/AdminCourses";
import SuperAdminOverview from "./pages/superadmin/SuperAdminOverview";
import SuperAdminUsers from "./pages/superadmin/SuperAdminUsers";
import SuperAdminLogins from "./pages/superadmin/SuperAdminLogins";
import SuperAdminOrders from "./pages/superadmin/SuperAdminOrders";
import SuperAdminCertificates from "./pages/superadmin/SuperAdminCertificates";
import SuperAdminEnrollments from "./pages/superadmin/SuperAdminEnrollments";
import SuperAdminSparky from "./pages/superadmin/SuperAdminSparky";
import SuperAdminExams from "./pages/superadmin/SuperAdminExams";
import SuperAdminExports from "./pages/superadmin/SuperAdminExports";
import SuperAdminContent from "./pages/superadmin/SuperAdminContent";

function AppRouter() {
  const location = useLocation();
  if (typeof window !== "undefined" && location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/courses" element={<Courses />} />
      <Route path="/courses/:courseId" element={<CourseDetail />} />
      <Route
        path="/courses/:courseId/modules/:moduleId"
        element={<ProtectedRoute><ModuleViewer /></ProtectedRoute>}
      />
      <Route
        path="/courses/:courseId/exam"
        element={<ProtectedRoute><ExamIntro /></ProtectedRoute>}
      />
      <Route
        path="/courses/:courseId/exam/attempt/:attemptId"
        element={<ProtectedRoute><ExamAttempt /></ProtectedRoute>}
      />
      <Route path="/verify/:certificateId" element={<Verify />} />
      <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
      <Route path="/checkout/cancel" element={<ProtectedRoute><CheckoutCancel /></ProtectedRoute>} />
      <Route
        path="/dashboard"
        element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
      />

      {/* Phase 6 — Admin */}
      <Route
        path="/admin"
        element={<RoleGuard roles={["admin", "super_admin"]}><AdminShell /></RoleGuard>}
      >
        <Route index element={<Navigate to="/admin/courses" replace />} />
        <Route path="courses" element={<AdminCourses />} />
      </Route>

      {/* Phase 6 — Super Admin */}
      <Route
        path="/superadmin"
        element={<RoleGuard roles={["super_admin"]}><SuperAdminShell /></RoleGuard>}
      >
        <Route index element={<SuperAdminOverview />} />
        <Route path="users" element={<SuperAdminUsers />} />
        <Route path="logins" element={<SuperAdminLogins />} />
        <Route path="enrollments" element={<SuperAdminEnrollments />} />
        <Route path="orders" element={<SuperAdminOrders />} />
        <Route path="certificates" element={<SuperAdminCertificates />} />
        <Route path="sparky" element={<SuperAdminSparky />} />
        <Route path="exams" element={<SuperAdminExams />} />
        <Route path="exports" element={<SuperAdminExports />} />
        <Route path="content" element={<SuperAdminContent />} />
      </Route>

      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
